// tslint:disable max-line-length
import * as Preact from 'preact'
import { IClip } from '../../../../../types'
import { firebaseInstance } from '../../../../db/firebase'
import { waitUntil } from '../../../../../lib/wait-until'
import { bem } from '@nrk/dh-utils'
import * as styles from './index.css'
const { h, Component } = Preact

class ViewCounter extends Component<
  { clip: IClip },
  { viewCount?: number; viewCountId: string; hidden: boolean }
> {
  public state = {
    viewCount: undefined,
    viewCountId: '',
    hidden: true
  }
  public componentDidMount() {
    this.updateViewCount(this.props.clip.id)
  }

  public componentWillReceiveProps(nextProps: { clip: IClip }) {
    if (this.props.clip.id !== nextProps.clip.id) {
      this.setState({ hidden: true })
      this.updateViewCount(nextProps.clip.id)
    }
  }

  public updateViewCount = async (id: string) => {
    if (!firebaseInstance) {
      await waitUntil(() => !!firebaseInstance, 1000).catch(console.error)
    }

    if (firebaseInstance) {
      const viewCount = await firebaseInstance.getViewCount(id)
      if (id !== this.props.clip.id) {
        return
      }
      this.setState({ viewCount, viewCountId: id, hidden: false })
    }
  }
  public render() {
    const { viewCount, hidden } = this.state
    const { views } = this.props.clip
    const formatedViewCount = formatNumber(viewCount || views || 0)

    return (
      <div class={bem(styles['view-count'], { hidden })}>
        {/* <ViewIcon /> */}
        <span class={styles['view-count__text']}>
          {formatedViewCount} visninger
        </span>
      </div>
    )
  }
}

const ViewIcon = () => {
  return (
    <svg
      class={styles['view-count__icon']}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
    >
      <path d="M7.5 11.9C4 11.9.6 8.3.4 8.1l-.3-.4.3-.3C.6 7.2 4 3.6 7.5 3.6c3.5 0 6.9 3.6 7.1 3.8l.3.3-.3.3c-.2.2-3.6 3.9-7.1 3.9zm-6-4.2c.9.9 3.5 3.1 6 3.1s5.1-2.2 6-3.1c-.9-.9-3.5-3.1-6-3.1s-5.1 2.3-6 3.1z" />
      <circle cx="7.5" cy="7.7" r="2.1" />
    </svg>
  )
}

const formatNumber = (viewCount: number) => {
  try {
    return viewCount.toLocaleString()
  } catch (err) {
    return '0'
  }
}

export { ViewCounter }
